

interface Section {
  title: string;
  descriptions:  Array<Description>;

}

interface Description {
  description: string;
}

import { defineComponent, PropType } from "vue";

export default defineComponent({
  name: "DropDownSection",
  components: {},
  props: {
    title: String,
    list: Array as PropType<Array<Section>>,
  },
});
